import React from 'react';
import MenuContent from '../MenuContent';
import FastLinks from '../FastLinks';

const IslandsBlock = ({ islands, fastLinks }) => {
  const isMobile = window.innerWidth < 768;

  return (
    isMobile ?
      <MenuContent className="col-lg-3 islands-block">
        <ul className="islands-list">
          {
            islands.map(region => (
              <li key={region.regionName}>
                <a href={region.link}>
                  <span className="mobile-title">{region.regionName}
                    {region.isNewDestination && <span className="new-destination">NEW DESTINATION</span>}
                  </span>
                </a>
              </li>
            ))
          }
        </ul>
        <FastLinks data={fastLinks} />
      </MenuContent>
      :
      <MenuContent className="islands-block sm-12">
        <ul className="islands-list row util-justify-center">
          {islands.map(region => (
            <li key={region.regionName} className="md-6 lg-3 sm-6">
              <a href={region.link} className="island-link">
                <img className="util-img-responsive bg-blue" src={region.img} alt={region.regionName} />
                { region.isNewDestination &&
                  <div className="island-subtitle">NEW DESTINATION</div>
                }
                <div className="island-title">{region.regionName}</div>
              </a>
            </li>
          ))}
        </ul>
        <FastLinks data={fastLinks} />
      </MenuContent>
  );
};

IslandsBlock.defaultProps = {
  islands: [],
  fastLinks: [],
};

export default IslandsBlock;



// WEBPACK FOOTER //
// ./js/components/global/menu/menuBlocks/IslandsBlock.js